
import { H6 } from "../../AbstractElements";
import { Link } from "react-router-dom";
import { Href } from "../../utils/Constant";
import { Badge, Button } from "reactstrap";
import { Edit } from "react-feather";
import { Fragment } from "react/jsx-runtime";
import { useState } from "react";

interface FeedbackTableBodyProps {
  feedbacks: any
}

const FeedbackTableBody: React.FC<FeedbackTableBodyProps> = ({ feedbacks = [] }) => {
  return (
    <Fragment>
      <tbody>
        {feedbacks.map((feedback: any, i: any) => (
          <tr key={i}>
            <td>
              {i + 1}
            </td>
            <td>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 ms-2">
                  <Link to={Href}>
                    <H6>{feedback.subject}</H6>
                  </Link>
                </div>
              </div>
            </td>
            <td className="project-dot">
              <div className="d-flex">
                <div className="flex-shrink-0">
                  <span className={`bg-${feedback.color}`} />
                </div>
                <div className="flex-grow-1">
                  <H6>{feedback.description}</H6>
                </div>
              </div>
            </td>
            <td> {feedback.username}</td>
            <td> {feedback.created_at}</td>
          </tr>
        ))}
      </tbody>
    </Fragment>
  );
};

export default FeedbackTableBody;
